import React from "react";
import "./Contact.css";
import { VscGithub } from "react-icons/vsc";
import { CgMail } from "react-icons/cg";
import { BsTwitter, BsFillTelephoneFill, BsMedium } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { ThemeContext } from "../../Context/theme";

export const Contact = () => {
  const [{ themename, toggeltheme }] = React.useContext(ThemeContext);
  return (
    <>
      <div className={`${themename} section`}>
        <h2 className="section__title" data-aos="fade-right">
          Get in <span className="different">Touch</span>
        </h2>
        <div className="contactcontainer" data-aos="fade-right">
          <a
            href="https://www.linkedin.com/in/sanket-patil-455700188/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="linkedin" />
          </a>
          <a
            href="https://github.com/sanketpatil05"
            target="_blank"
            rel="noreferrer"
          >
            <VscGithub className="github" />
          </a>
          <a
            href="https://medium.com/@sanketp441"
            target="_blank"
            rel="noreferrer"
          >
            <BsMedium />
          </a>
         
        </div>
        <div>
          <div id={`  ${themename} `} id = "mine"><p>Email:patilsanket209@gmail.com</p></div>
          <div id={`${themename} `} id = "mine1"><p>Phone:+919011639623</p></div>
        </div>
      </div>
    </>
  );
};
